/**
 * props 示例
 * value: {
 *    no: 1,
 *    size: 16,
 *    total: 1234
 * }
 * pageKey: {
 *    no: 'pageNo',
 *    size: 'pageSize',
 *    total: 'total'
 * }
 */
export let props = [
  'total', 'tableData', 'tableProp', 'highlightCurrentRow', 'page', 'pageSize',"mergeList",
  'layout', 'pagerCount', 'noPagination', 'expand', 'layout','useSelection','rowStyle','height','border','id','showsummary']
export let model = {
  defaultPageSize: 10,
  // page: {
  //   page: 1,
  //   pageSize: 10
  // },
  selectedData: [],
  notSlice: true,
  tableHeight: '100%',
  tableSort: {
    ascending: undefined,
    descending: undefined
  }
}
export let computed = {
  data: {
    get () {
      return this.tableData
    },
    set (val) {
      this.$emit('update:tableData', val)
    }
  },
  // 为了兼容旧打逃的代码
  customPage: {
    get () {
      if (this.page instanceof Object) {
        return this.page.page
      } else {
        return this.page
      }
    },
    set (val) {
      if (this.page instanceof Object) {
        this.page.page = val
      } else {
        this.$emit('update:page', val)
      }
    }
  },
  customPageSize: {
    get () {
      if (this.page instanceof Object) {
        return this.page.pageSize
      } else {
        return this.pageSize
      }
    },
    set (val) {
      if (this.page instanceof Object) {
        this.page.pageSize = val
      } else {
        this.$emit('update:pageSize', val)
      }
    }
  },
  slots () {
    return this.tableProp.filter(item => item.slot)
  }
}
